import { VerificationAppDocumentType } from "../../../app/models";
import { DefaultEntry } from "./DefaultEntry";
import { IdentificationEntry } from "./IdentificationEntry";
import { UserInformationEntry } from "./UserInformationEntry";
import { StepRegistryEntry } from "./types";

const registry: Partial<
  Record<VerificationAppDocumentType, StepRegistryEntry>
> = {
  [VerificationAppDocumentType.Identification]: IdentificationEntry,
  [VerificationAppDocumentType.UserInformation]: UserInformationEntry,
};

export function getRegistryEntry(
  type: VerificationAppDocumentType
): StepRegistryEntry {
  return registry[type] ?? DefaultEntry;
}
